var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticStyle:{"background":"#eee"},attrs:{"id":"core-toolbar","flat":"","prominent":""}})}
var staticRenderFns = []

export { render, staticRenderFns }